<template>
  <button class="btn btn-link mb-2" type="button" @click="onClick">
    <i class="bi bi-file-earmark-arrow-down" /> {{ $t("exportar") }}
  </button>
</template>

<script>
import { getAllFeedbackData } from '../feedbackService';

export default {
  props: {
    headers: { type: Array, required: true },
    sort: { type: String, required: true },
    order: { type: String, required: true },
    search: { type: String, default: '' },
    incluirLidos: { type: Boolean, default: false },
  },
  methods: {
    async onClick() {
      const rows = await getAllFeedbackData(this.$props);
      rows.unshift(this.headers);
      const content = 'data:text/csv;charset=utf-8,\ufeff' + rows.map((e) => e.join(';')).join('\n');
      const encodedUri = encodeURI(content);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'comentários.csv');
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
